import React from 'react';

import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './FullSectionCard.module.css';
import { ArrowLink } from './Links';
import PageSection from './PageSection';

const FullSectionCard = ({ heading, label, backColor, imageSrc, backImageSrc, link, position, section }) => {
  const gradients = {
    Pink: 'linear-gradient(180deg, rgba(248,89,139, 0.9) 0%, rgba(155,21,63, 0.9) 100%)',
    Blue: 'linear-gradient(180deg, rgba(0,156,226, 0.9) 0%, rgba(3,51,103, 0.9) 100%)',
    Purple: 'linear-gradient(180deg, rgba(128,83,255, 0.9) 0%, rgba(43,24,97, 0.9) 100%)',
    Green: 'linear-gradient(180deg, rgba(15,166,157, 0.9) 0%, rgba(3,69,73, 0.9) 100%)',
  };

  let backColorGradient = gradients[backColor] ? gradients[backColor] : '';
  let positionClass = position === 'Right' ? styles['method_2'] : '';
  // let textColorClass = position === 'Right' && backColorGradient === '' ? styles['noBgColor'] : '';

  const bgStyles = {
    backgroundImage: `url(${backImageSrc})`,
  };
  return (
    <PageSection fullBleed noPad>
      <div className={styles.bannerParent + ' ' + positionClass} style={{ background: backColorGradient }}>
        <div
          className={[styles.scndBgImg, backColorGradient ? '' : styles.noGradient].join(' ')}
          style={bgStyles}
        ></div>
        <div className={styles.bannerLeft}>
          <div
            className={[styles.banner_imgShow, backColorGradient ? '' : styles.noGradient].join(' ')}
            style={bgStyles}
          />
          <div className={[styles.contentimgParent, backColorGradient ? '' : styles.noGradient].join(' ')}>
            <div className={styles.contentImg}>
              <img src={imageSrc} alt="" />
            </div>
          </div>
        </div>
        <div className={styles.bannerRight}>
          <h3>{heading}</h3>
          <p>
            <RichTextConverter copy={section?.copy} />
          </p>
          {link && <ArrowLink label={label} url={link} isArrowRight isExternal className={styles.arrowLink} />}
        </div>
      </div>
    </PageSection>
  );
};

export default FullSectionCard;
